/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Not_Found_TitleInputs */

const en_agent_authorization_not_found_title = /** @type {(inputs: Agent_Authorization_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorization request unavailable`)
};

const zh_agent_authorization_not_found_title = /** @type {(inputs: Agent_Authorization_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权请求不可用`)
};

/**
* | output |
* | --- |
* | "Authorization request unavailable" |
*
* @param {Agent_Authorization_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_not_found_title = /** @type {((inputs?: Agent_Authorization_Not_Found_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Not_Found_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_not_found_title(inputs)
	return zh_agent_authorization_not_found_title(inputs)
});
export { agent_authorization_not_found_title as "agent.authorization.not_found_title" }